import { useTableContext } from "#Contexts/TableContext"
import cn from "#Utils/cn"

import Icon from "../Icon"
import LoadingSpinner from "../LoadingSpinner"

export const LoadMoreMessage = ({
  isLoading,
  direction = "down",
  message = "Load more data",
  loadingMessage = "Loading more data",
}) => {
  if (isLoading) {
    return (
      <LoadingSpinner
        text={loadingMessage}
        spinnerClassName="bg-[#1B44DA]"
        textClassName="text-content-default"
      />
    )
  }

  return (
    <>
      <Icon
        size="xs"
        tone="link"
        name={cn("fa", {
          "fa-angle-down": direction === "down",
          "fa-angle-up": direction === "up",
        })}
      />
      {message}
    </>
  )
}

LoadMoreMessage.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  direction: PropTypes.oneOf(["down", "up"]),
  message: PropTypes.string,
  loadingMessage: PropTypes.string,
}

export const LoadMoreButton = ({ children, onClick, disabled, className }) => {
  const { table } = useTableContext()
  const colSpan = table.getFlatHeaders().length

  return (
    <tfoot>
      <tr>
        <td
          className="relative font-body bg-surface-highlight text-link text-xs h-8 border-b last:border-t last:border-b-0"
          colSpan={colSpan}
        >
          <div className="flex items-center justify-center leading-none h-full w-full">
            <button
              onClick={onClick}
              disabled={disabled}
              className={cn(
                "flex gap-2 items-center leading-none p-2 cursor-pointer select-none",
                className,
              )}
            >
              {children}
            </button>
          </div>
        </td>
      </tr>
    </tfoot>
  )
}

LoadMoreButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}
